import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Flame, ArrowRight } from "lucide-react";

export default function SuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center py-8 px-4">
      <Card className="max-w-md w-full rounded-2xl shadow-lg overflow-hidden">
        <CardContent className="p-8 text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>

          {/* Brand */}
          <div className="flex items-center justify-center gap-2 mb-4">
            <Flame className="w-6 h-6 text-ember" />
            <span className="font-heading text-xl text-sage-900">StreakChallenge</span>
          </div>

          {/* Message */}
          <h1 className="font-heading text-3xl text-sage-900 mb-3">
            Thanks!
          </h1>
          <p className="font-body text-lg text-muted-foreground mb-8">
            You're all set.
          </p>

          {/* CTA Button */}
          <Button
            onClick={() => navigate("/")}
            className="w-full rounded-full py-6 font-medium bg-ember hover:bg-ember/90 text-white"
          >
            Go to StreakChallenge
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
